<template>
  <div class="workout-confirm-exercise">
    <div class="scrollable">
      <div class="text-center pb-3">
        <span class="text-warning">Parabéns!</span>
        <h3 class="font-condensed mb-4">Seu treino foi concluído</h3>
      </div>

      <h5 class="mb-3">{{ exercise.title }}</h5>

      <div v-for="serie in exercise.series" :key="serie.id">
        <div class="serie-title">{{ serie.title }}</div>

        <div
          v-for="(rep, index) in serie.number_series"
          :key="`${serie.id}${rep}`"
          class="d-flex align-items-center py-2"
        >
          <span class="rep-number">0{{ index + 1 }}</span>
          <span>{{ reps[serie.id][rep].weight || 0 }} kg</span>
          <span class="flex-fill"></span>
          <span>{{ serie.cycles }} Rep</span>
        </div>
      </div>
    </div>

    <div class="fixed-bottom">
      <button
        class="btn btn-warning btn-strong rounded-pill w-100"
        @click="$emit('confirm')"
      >
        <loading :show="loading">
          FINALIZADO
        </loading>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    exercise: Object,
    reps: Object,
    loading: Boolean
  }
};
</script>

<style lang="scss" scoped>
.workout-confirm-exercise {
  position: relative;
  .scrollable {
    max-height: 500px;
    overflow-y: scroll;
    padding: 16px;
    padding-bottom: 80px;
  }

  .fixed-bottom {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 16px 10%;
    background-image: linear-gradient(to bottom, #13121200, #131212ee 50%);
  }

  .serie-title {
    background-color: rgba(0, 0, 0, 0.5);
    padding: 10px;
    border-radius: 6px;
    font-weight: 500;
    color: #bbbbbb;
    margin-bottom: 8px;
    margin-top: 16px;
  }

  .rep-number {
    width: 21px;
    height: 21px;
    border-radius: 21px;
    background: #787878;
    font-style: normal;
    font-weight: 500;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #131212;
    font-size: 14px;
    line-height: 150%;
    margin-right: 24px;
  }
}
</style>
